import { environment, cfg, brand } from "@crystal/config";
import { getGlobalThis, loadScript } from "@crystal/core/utils";
import { Queue } from "./queue.js";
import { formatData } from "./utag-data.js";
const queue = new Queue("utag", isUtagReady, (item) => {
  const { utag } = getGlobalThis();
  if (!utag)
    return;
  utag[item.action](formatData(item.data));
});
const tealiumScriptUrl = environment({
  default: cfg`https://tags.tiqcdn.com/utag/adidas/${brand}global/dev/utag.js`,
  staging: cfg`https://tags.tiqcdn.com/utag/adidas/${brand}global/qa/utag.js`,
  production: cfg`https://tags.tiqcdn.com/utag/adidas/${brand}global/prod/utag.js`
});
function fireUtagViewEvent(data) {
  trackEvent("view", data);
}
function fireUtagLinkEvent(data) {
  trackEvent("link", data);
}
function isUtagPending() {
  return !queue.isEmpty();
}
function clearUtagQueue() {
  queue.clear();
}
function trackEvent(action, data) {
  const { utag } = getGlobalThis();
  if (utag && isUtagReady() && queue.isEmpty()) {
    utag[action](formatData(data));
    return;
  }
  queue.add({
    action,
    data
  });
  queue.tryCommit();
}
function isUtagReady() {
  const { utag } = getGlobalThis();
  if (!utag)
    return false;
  const isInitialized = "link" in utag && "view" in utag && utag.handler && utag.handler.iflag;
  return isInitialized || false;
}
function loadUtagAgent(context) {
  if (isUtagReady()) {
    return Promise.resolve();
  }
  const win = getGlobalThis();
  win.utag_cfg_ovrd = win.utag_cfg_ovrd || {};
  win.utag_cfg_ovrd.noview = true;
  return loadScript(tealiumScriptUrl.evaluateWithContext(context), "tealium-agent-loader", {
    disableCrossOrigin: true
  });
}
export {
  clearUtagQueue,
  fireUtagLinkEvent,
  fireUtagViewEvent,
  isUtagPending,
  isUtagReady,
  loadUtagAgent
};
//# sourceMappingURL=utag.js.map
